var HashMap = require("../collections/hashMap.js");
var Bins = require("../collections/bins.js");
var hash = require("../hash.js");
var AbstractInstance = require("./instanceBuilder/abstractInstance.js");

var Hashifier = {  // TODO: better name?
    hashify: function(data){

        var hashifyNode = function(node){
            var json = { $class: node.constructor.$class };
            var sortedMembers = node.collections.keys().sort();

            sortedMembers.forEach(function(membergetName) {
                var member = node.collections.get(membergetName);
                // if (member.isPersistent() == false) continue;
                switch(member.getType()) {
                case "value":
                    json[member.getName()] = hashifyValue(member(), member);
                    break;

                case "map":
                    var mapContent = [];
                    member.forEach(function(key, val){
                        var keyJson = hashifyValue(key, member);
                        var valJson = hashifyValue(val, member);
                        mapContent.push({keyJson: keyJson, keyStr: JSON.stringify(keyJson), valJson: valJson});
                    });
                    mapContent.sort(function(a, b){
                        return a.keyStr < b.keyStr ? -1 : a.keyStr > b.keyStr ? 1:0;
                    });
                    json[member.getName() + "-map"] = mapContent.map(function(el){return [el.keyJson, el.valJson];});
                    break;

                case "set":
                    json[member.getName() + "-set"] = orderSet(member).map(function(el){return el.json;});
                    break;

                case "list":
                    var listJson = [];
                    member.forEach(function(idx, val){
                        listJson.push(hashifyValue(val, member));
                    });
                    json[member.getName() + "-list"] = listJson;
                    break;

                default:
                    throw new Error();
                }
            });   // TODO: Possible improvement to avoid more false negatives: add number of referrers (in own tree), or even better: path to all referrers

            if(node instanceof AbstractInstance) {
                json["template"] = hashifyValue(node.template(), node.template);
            }
            return json;
        };

        var orderedSets = new HashMap();
        var pendingSetIndices = new Bins();

        var orderSet = function(set){
            if (orderedSets.contains(set)) return orderedSets.get(set); // if set is already ordered return ordered set
            orderedSets.put(set, "pending");    // mark set ordering as pending

            var setContent = [];
            var originalIdx = 0;
            set.forEach(function(val){
                var valJson = hashifyValue(val, set);
                setContent.push({val: val, idx: originalIdx++, json: valJson, str: JSON.stringify(valJson)});
            });
            setContent.sort(function(a, b){
                //Warning: in some cases the hash depends on the order of the elements in the set, which is defined by the insertion order.
                return a.str < b.str ? -1 : a.str > b.str ? 1: a.idx - b.idx; // sort on content, similar elements are sorted in original order
            });

            pendingSetIndices.get(set).forEach(function(obj){   // fill out pending set indices after set is ordered
                obj.path[obj.idx] = setContent.findIndex(function(el){return el.val == obj.val;});
            });

            orderedSets.put(set, setContent);
            return setContent;
        };

        var hashifyValue = function(val, member){
            if (val == null) return val;
            if (member.isOwner() && val.isObservableTreeNode) {
                return hashifyNode(val);
            }
            else if (!member.isOwner() && val.isObservableTreeNode){
                if (val.root != member.getTreeNode().root){ // if this is a cross-asset reference: get the asset information
                    //Note: the instance objects themselves are considered to have a stable hash without using the cross asset reference.
                    //If the hash of the instance object is not unique (e.g. SymbolTerminalInstance), the insertion order is used,
                    //which may be different depending on how the asset was loaded.
                    //E.g. the insertion order may differ if an asset was 'updated'.
                    return [val.root.getId(), val.$id];
                }
                var relPath = [];   // search relative path (in tree) from this node to the referenced node
                var thisPath = member.getTreeNode().getPath();
                var refPath = val.getPath();
                while(thisPath.length > 0 && refPath.length > 0 && thisPath[0].collection === refPath[0].collection && thisPath[0].key === refPath[0].key){
                    thisPath.shift(); // cut common ancestors to find joint
                    refPath.shift();
                }
                relPath.push(thisPath.length); // add number of parents until joint
                for (var i in refPath){
                    relPath.push(refPath[i].collection.getName());
                    if (refPath[i].collection.getType() === "set"){
                        var orderedSet = orderSet(refPath[i].collection);
                        if (orderedSet == "pending"){ // if set is not ordered yet:
                            pendingSetIndices.put(refPath[i].collection, {val: refPath[i].key, path: relPath, idx: relPath.length}); // register this path to fill out index when set is ordered
                            relPath.push("?");  // temporary use '?' as index
                        } else {
                            relPath.push(orderedSet.findIndex(function(el){return el.val == refPath[i].key;})); // find index of element in ordered set
                        }
                    } else if (refPath[i].key != undefined) relPath.push(refPath[i].key);
                }
                return relPath;
            }
            else if(typeof val === 'object' && val.getData) {
                var json = val.getData();
                json["$class"] = val.constructor.$class;
                return json;
            }
            else return val;
        };

        data = data || this.data;
        if(!data.constructor.$class){
            return hash.stringHash(JSON.stringify(data));
        }
        var json = hashifyNode(data);
        // console.log(JSON.stringify(json))
        return hash.stringHash(JSON.stringify(json));
    }
};

module.exports = Hashifier;
